import { castToOptionWithEmpty } from 'src/helpers/castToOption';

export enum CustomerLeadPurchaseFrequency {
  Weekly = 'WEEKLY',
  Monthly = 'MONTHLY',
  BiMonthly = 'BIMONTHLY',
  Quarterly = 'QUARTERLY',
  Yearly = 'YEARLY',
  BiYearly = 'BIYEARLY',
}

export const CUSTOMER_LEAD_PURCHASE_FREQUENCY_MAPPER: Readonly<Record<CustomerLeadPurchaseFrequency, string>> =
  Object.freeze({
    [CustomerLeadPurchaseFrequency.Weekly]: 'Weekly',
    [CustomerLeadPurchaseFrequency.Monthly]: 'Monthly',
    [CustomerLeadPurchaseFrequency.BiMonthly]: 'Twice a Month',
    [CustomerLeadPurchaseFrequency.Quarterly]: 'Quarterly',
    [CustomerLeadPurchaseFrequency.Yearly]: 'Yearly',
    [CustomerLeadPurchaseFrequency.BiYearly]: 'Twice a Year',
  });

export const CustomerLeadPurchaseFrequencyOptions = castToOptionWithEmpty({
  enumeration: CustomerLeadPurchaseFrequency,
  formatter: CUSTOMER_LEAD_PURCHASE_FREQUENCY_MAPPER,
});
